import { IOffer } from 'shared/offer';

export function getIsUserIdentifiedByDocuments(offer: IOffer): boolean {
  return !!offer.user?.agentModerationInfo?.isUserIdentifiedByDocuments;
}
